// extracted by mini-css-extract-plugin
module.exports = {"box":"mailMain_box__1wQkf","nav":"mailMain_nav__NN79W","letterBox":"mailMain_letterBox__1SXlW"};